// Path to a project's dashboard, optionally deep-linked to a specific collector's
// fase. `?tab=dashboard` opens the dashboard tab; `&collector=<id>` is read by
// DashboardTab to select that collector's fase once the fase mapping loads.
export function projectDashboardPath(projectId: number, collectorId?: number | null): string {
  const collector = collectorId != null ? `&collector=${collectorId}` : '';
  return `/project/${projectId}?tab=dashboard${collector}`;
}
